/**
 * Maintenance Mode Configuration
 * 
 * To ENABLE maintenance mode:
 *   Set MAINTENANCE_ENABLED = true; (or add REACT_APP_MAINTENANCE_MODE=true in .env.production)
 * 
 * To DISABLE maintenance mode:
 *   Set MAINTENANCE_ENABLED = false;
 * 
 * Admins can always bypass maintenance screen using URL parameter ?admin_bypass=aminii
 * or by navigating directly to /AdminAminii
 */

export const MAINTENANCE_CONFIG = {
  // Toggle this flag or set process.env.REACT_APP_MAINTENANCE_MODE
  enabled: process.env.REACT_APP_MAINTENANCE_MODE === "false" || false, // Currently ACTIVE

  brandName: "AMINII CLOTHING",
  tagline: "Curating Elegance & Perfection",
  title: "Under Scheduled Maintenance",
  message:
    "We are currently updating our systems and polishing our collections to bring you an elevated shopping experience. Our boutique will be back online shortly.",
  estimatedTime: "Back online shortly",
  whatsappNumber: "919606132902", // Update if needed
  whatsappMessage: "Hi Aminii Team, I am browsing aminii.in and would like to inquire about products.",
  instagramUrl: "https://www.instagram.com/aminii.clothing.in",
  supportEmail: "aminiiclothings@gmail.com",
};

export const isMaintenanceModeActive = () => {
  // Check URL query parameter bypass (?admin_bypass=aminii)
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    if (params.get("admin_bypass") === "aminii") {
      sessionStorage.setItem("aminii_maintenance_bypass", "true");
      return false;
    }
    if (sessionStorage.getItem("aminii_maintenance_bypass") === "true") {
      return false;
    }
  }

  return Boolean(MAINTENANCE_CONFIG.enabled);
};
